// extracted by extract-css-chunks-webpack-plugin
module.exports = {"textarea":"_3sOXaP","default":"_2WySit","fullWidth":"_1i89wy","noResize":"potn0n"};